<template>
  <div class="sign-in__password">
    <div class="sign-in__password__content-top">
      <h2 class="sign-in__password__title text-center text-white">
        {{ "login.email_login.welcome_back" | trans }}, <br />{{
          loginFirstName
        }}!
      </h2>
    </div>
    <div class="sign-in__password__content-bottom">
      <div class="sign-in__password__user d-flex flex-wrap">
        <app-avatar :name="loginFullName" :url="loginAvatarUrl" size="sm" />
        <div
          class="sign-in__password__user__info d-flex align-content-center flex-wrap"
        >
          <h4 v-if="loginFullName" class="mb-0">{{ loginFullName }}</h4>
          <p v-if="loginUsername" class="text-md">{{ loginUsername }}</p>
        </div>
      </div>

      <b-form @submit.prevent="onSubmit">
        <input
          type="text"
          class="d-none"
          name="username"
          :value="loginUsername"
          autocomplete="username"
        />
        <app-form-input
          :placeholder="$trans('ui.password')"
          v-model="password"
          variant="white"
          type="password"
          autocomplete="current-password"
          :error="errorMessage"
        />
        <app-button
          size="lg"
          type="submit"
          variant="light"
          :loading="submitted"
          :disabled="submitted"
          block
        >
          {{ "login.email_login.next" | trans }}</app-button
        >
      </b-form>

      <b-link
        class="sign-in__password__forgot"
        :href="$websitePath('/resetting/request-token?context=default')"
        >{{ "security.login.forgot_password" | trans }}</b-link
      >

      <b-button size="lg" block :to="{ name: 'login-email' }">
        {{ "security.sign_different_account" | trans | trans }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppFormInput from "@/components/form/FormInput";
import AppAvatar from "@/components/user/Avatar";
import AppButton from "@/components/ui/Button";
import { createValidationError } from "@/utils/validation";

export default {
  name: "LoginPasswordView",
  components: { AppButton, AppAvatar, AppFormInput },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.loginUsername) {
        return;
      }

      next({ name: "login-email" });
    });
  },
  computed: {
    ...mapGetters("security", [
      "loginFullName",
      "loginUsername",
      "loginFirstName",
      "loginAvatarUrl",
    ]),
  },
  methods: {
    async onSubmit() {
      try {
        this.submitted = true;
        this.errorMessage = null;
        await this.$auth.login(this.loginUsername, this.password);

        this.$router.push({ name: "my-plane" });
      } catch (e) {
        const ve = createValidationError(e);
        this.errorMessage = ve.errors.message;
      } finally {
        this.submitted = false;
      }
    },
  },
  data() {
    return {
      submitted: false,
      password: null,
      errorMessage: null,
    };
  },
};
</script>

<style lang="scss" scoped>
.sign-in {
  transition: 0.5s cubic-bezier(0.55, 0, 0.1, 1);
  &__password {
    &__user {
      padding-right: 1.5rem;
      padding-left: 1.5rem;
      margin-bottom: 1.5rem;
      padding-top: 0.1875rem;
      position: relative;
      min-height: 4rem;
      color: $white;
      h4 {
        display: block;
      }
      p {
        @extend .ringside-light;
      }
      h5,
      p {
        margin-bottom: 0;
      }
      &__info {
        width: calc(100% - 64px);
        padding-left: 0.75rem;
      }
    }
    &__title {
      @extend .ringside-med;
      padding-top: 6.875rem;
      padding-bottom: 7.5rem;
    }
    &__forgot {
      @extend .ringside-light;
      display: block;
      text-align: center;
      line-height: 3.375rem;
      color: $white;
    }
    &__content-bottom,
    &__title {
      max-width: 20rem;
      margin: 0 auto;
    }
    &__icon {
      position: relative;
      top: -0.125rem;
      width: 0.625rem;
      margin-right: 0.625rem;
    }
    &__desc {
      @extend .ringside-light;
      font-size: 0.875rem;
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }
}
@include media-breakpoint-up(lg) {
  .sign-in {
    &__password {
      &__title {
        max-width: 23.75rem;
        font-size: 2.25rem;
        line-height: 1.1;
        padding-top: 4rem;
        padding-bottom: 4rem;
      }
    }
  }
}
</style>
